import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-replay',
  templateUrl: './replay.component.html',
  styleUrls: ['./replay.component.scss'],
})
export class ReplayComponent {
  @Input() replayController;
  isMobile = window.innerWidth < 640;
  isTablet = window.innerWidth >= 640 && window.innerWidth < 1024;
  isDesktop = window.innerWidth >= 1024;
}
